import {
  DATA_SOURCES_TEST_PREFIX,
  kConnectorOptionalKeys,
  kKeyToLabelAndDefaultText,
  kConnectorDataKeys,
  kConnectorTEParams,
  kPasswordMaskingKeys
} from "./Utils";
import { appstr } from "@coreapp/utils/appstr";
import { appcstr } from "@coreapp/utils/appcstr";

import { Flex, Input, PasswordInput, TextArea } from "@theorgchartdev/storybook";

const GetRequiredKeys = source => {
  // this line is so that when there is no reference in the object, there's no crash.
  const requiredKeys = kConnectorDataKeys[source] || [];
  // return a copy of the list is the safest way. this fn name is Get, not GetSetGo.
  return [...requiredKeys];
};

export const GetOptionalKeys = source => {
  // this line is so that when there is no reference in the object, there's no crash.
  var optionalKeys = kConnectorOptionalKeys[source] || [];
  // return a copy of the list is the safest way. this fn name is Get, not GetSetGo.
  return [...optionalKeys];
};

const DoLogicOnReqKeys = config => {
  const source = config.source;
  let requiredKeys = GetRequiredKeys(source);
  if (source === "Workday" && config.isOAuth)
    requiredKeys = [...kConnectorDataKeys["WorkdayAPI"], "workdayhc"];
  if (source === "Sage 300 ZA" && config.isBasicAuth)
    requiredKeys = [...requiredKeys, "username", "password"];
  return requiredKeys;
};

export const AreCredsFilled = config => {
  if (!config?.source) return false;
  const requiredKeys = DoLogicOnReqKeys(config);
  return !requiredKeys.some(function (key) {
    return !config[key];
  });
};

export const GetAllKeys = source => {
  return [...GetRequiredKeys(source), ...GetOptionalKeys(source)];
};

const BuildDefaultInputOptions = keys => {
  let inputOptions = [];
  keys.forEach(key => {
    let label = key;
    let placeholder = key;
    if (kKeyToLabelAndDefaultText[key]) {
      label = appcstr(kKeyToLabelAndDefaultText[key][0]);
      placeholder = appcstr(kKeyToLabelAndDefaultText[key][1]);
    }
    let inputOption = {};
    inputOption.dataKey = key;
    inputOption.label = label;
    inputOption.placeholder = placeholder;
    inputOption.inputProps = { ...kConnectorTEParams[key] };
    inputOption.passwordMask = kPasswordMaskingKeys.includes(key?.toLowerCase());
    inputOptions.push(inputOption);
  });
  return inputOptions;
};

export const ConnectorInputComponent = ({ passwordMask, type, ...props }) => {
  if (type === "textarea") {
    return <TextArea {...props} />;
  }
  if (passwordMask) {
    return <PasswordInput {...props} />;
  }
  return <Input {...props} />;
};

export const DataSetupInputComposite = ({
  config,
  index,
  onChange,
  size,
  doLookup = true,
  inputOptions = []
}) => {
  let inputOptionList = inputOptions;
  if (doLookup) {
    let inputKeys = GetAllKeys(config["source"]);
    inputOptionList = BuildDefaultInputOptions(inputKeys);
  }

  const handleInput = (e, key) => {
    config[key] = e.target.value;
    onChange(config, index);
  };

  return (
    <Flex direction={"column"}>
      {inputOptionList.map(option => {
        let label = option.label;
        if (option.optional) label = option.label + " (" + appstr("Optional") + ")";
        let placeholder = option.placeholder;
        let dataKey = option.dataKey;
        let value = option.value ?? config[dataKey];
        let onInputChange = option.onChange;
        let inputProps = option.inputProps ? option.inputProps : {};
        const doPasswordMask = option.passwordMask === true;

        return (
          <ConnectorInputComponent
            dataTestId={`${DATA_SOURCES_TEST_PREFIX}-connector-${config["source"]}-${dataKey}`}
            passwordMask={doPasswordMask}
            label={label}
            key={dataKey}
            placeholder={placeholder}
            value={value}
            autocomplete={"off"}
            type={"text"}
            size={size}
            onChange={onInputChange ? e => onInputChange(e, dataKey) : e => handleInput(e, dataKey)}
            {...inputProps}
          />
        );
      })}
    </Flex>
  );
};
